"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYPAL = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
var PaypalIcon_1 = require("../BankDetails/icons/PaypalIcon");
exports.PAYPAL = 'paypal';
function PaypalPaymentTile(_a) {
    var radioGroupName = _a.radioGroupName, selectedAccountId = _a.selectedAccountId, onChange = _a.onChange, ga = _a.ga;
    var addPaypalRadioBtnData = {
        id: exports.PAYPAL,
        isMuted: false,
        hasSolidBorder: true,
        isSelected: selectedAccountId === exports.PAYPAL,
        value: exports.PAYPAL,
        onChange: function () {
            if ((ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.payment') {
                ga === null || ga === void 0 ? void 0 : ga.push('click.1.paypal');
            }
            onChange(exports.PAYPAL);
        },
        headerNode: (react_1.default.createElement(asg_1.Text, { color: asg_1.colors.text.light, size: "16px !important", "data-testid": "addpaypal", lineHeight: "20px" }, "Paypal")),
        icon: (react_1.default.createElement(asg_1.Icon, { id: "paypalIcon", "data-testid": "paypalIcon", icon: PaypalIcon_1.PaypalIcon, css: { margin: 'auto', height: '48px !important', width: '48px !important' } })),
        containerBoxProps: { minWidth: '100% !important', maxWidth: '100% !important' }
    };
    (0, react_1.useEffect)(function () {
        if ((ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.payment') {
            ga === null || ga === void 0 ? void 0 : ga.push('load.0.paypal');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.FlexGrid, null,
            react_1.default.createElement(asg_1.FlexGridItem, null,
                react_1.default.createElement(asg_1.RadioGroup, { name: radioGroupName, id: radioGroupName, value: selectedAccountId },
                    react_1.default.createElement(asg_1.Box, { key: addPaypalRadioBtnData.id, margin: { top: 'small' } },
                        react_1.default.createElement(myaccount_frontend_shared_1.RadioButtonTile, { key: addPaypalRadioBtnData.id, id: addPaypalRadioBtnData.id, isMuted: addPaypalRadioBtnData.isMuted, isSelected: selectedAccountId === addPaypalRadioBtnData.value, value: addPaypalRadioBtnData.value, description: addPaypalRadioBtnData.description, descriptionNode: addPaypalRadioBtnData.descriptionNode, onChange: addPaypalRadioBtnData.onChange, headerNode: addPaypalRadioBtnData.headerNode, icon: addPaypalRadioBtnData.icon, containerBoxProps: addPaypalRadioBtnData.containerBoxProps })))))));
}
exports.default = PaypalPaymentTile;
//# sourceMappingURL=PaypalPaymentTile.js.map